import * as Yup from 'yup'
import cutileiApi from '../services/cutileiApi'
import Auth from '../services/auth'

const isNonExistingUser = async (key, value, customerID) => {
  const businessId = Auth.getBusinessId ()
  const query = `business_id=${businessId}&customer_id=${customerID}`

  try {
    await cutileiApi.post (`/customers/verify_existing?${query}`, { [key]: value })
    return { valid: true }
  } catch (error) {
    return {
      valid: false,
      message: error.response?.data?.message
    }
  }
}

const phoneRegex = /\(|\)| |-/g

const customerValidator = Yup.object ({
  id: Yup.string (),

  name: Yup.string ()
    .required ('Digite um nome')
    .min (4, 'O nome deve conter no minimo 4 caracteres')
    .max (128, 'O nome deve conter até 128 caracteres'),

  email: Yup.string ()
    .email ('Insira um email válido')
    .max (128, 'O e-mail deve conter até 128 caracteres')
    .test ('newEmail', 'Este endereço de e-mail já foi cadastrado', async function (value) {
      if (!value) return true
      const { id } = this.parent
      const result = await isNonExistingUser ('email', value, id)

      if (!result.valid) {
        return this.createError ({ message: result.message })
      }
      return true
    }),
    
  phone: Yup.string ()
    .test ('validPhone', 'Insira um número válido', function (value) {
      if (!value) return true
      return value.replace (phoneRegex, '').length >= 10
    }).test ('newPhone', 'Este celular já foi cadastrado', async function (value) {
      if (!value) return true
      const { id } = this.parent
      const result = await isNonExistingUser ('phone', value, id)

      if (!result.valid) {
        return this.createError ({ message: result.message })
      }
      return true
    }),

  gender: Yup.object ().nullable (),

  birth: Yup.string ()
    .min (8, 'Digite uma data válida (dd/mm/aaaa)')
})

export default customerValidator
